import { Modal, Button } from '@prosolve/common-components-ui'

export default ({
  data = {},
  onClose
}) => {
  const {
    answers = [],
    isFilesOnly,
    hasMulti
  } = data;

  const standardAnswers = []
  const imageAndFileAnswers = [];
  answers.forEach(answer => {
    if (answer.questionType === 'fileupload') {
      imageAndFileAnswers.push(answer)
    } else {
      standardAnswers.push(answer)
    }
  });

  const imageFormats = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg']
  
  const images = [];
  const files = [];
  imageAndFileAnswers.forEach(imageAndFileAnswer => {
    const { answer = '' } = imageAndFileAnswer;
    const answerImageAndFiles = answer.split(' ; ')
    answerImageAndFiles.forEach(answerImageAndFile => {
      const isImage = imageFormats.some(ext => answerImageAndFile.toLowerCase().endsWith(ext));
      if (isImage) {
        images.push(answerImageAndFile)
      } else {
        files.push(answerImageAndFile)
      }
    });
  });

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Close'}
      </Button>
    </div>
  )

  const onClickItem = (url) => {
    window.open(url, "_blank")
  }

  const title = isFilesOnly ?
    `View Uploaded File${hasMulti ? 's' : ''}` : 
    'Assessment Answer Details'

  return (
    <Modal title={title} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        {
          images.length > 0 &&
          <>
            {
              !isFilesOnly &&
              <div style={{
                color: '#565656',
                fontSize: '24px',
                fontWeight: 'bold',
                borderBottom: '1px solid #c2c9d1'
              }}>
                {'Images'}
              </div>
            }
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              padding: '20px',
              gap: '10px 10px',
              justifyContent: 'left',
            }}>
              {
                images
                  .map((imageUrl, index) => {
                    return (
                      <div
                        key={`${imageUrl}-${index}`}
                        style={{
                          maxWidth: 'calc(66% - 10px)',
                          cursor: 'pointer',
                          flexGrow: 1,
                          height: '220px',
                        }}
                        onClick={() => onClickItem(imageUrl)}
                      >
                        <img
                          style={{
                            width: '100%',
                            maxHeight: '100%',
                            minWidth: '100%',
                            objectFit: 'cover',
                            borderRadius: '5px'
                          }}
                          src={imageUrl} alt='uploadedPic' />
                      </div>
                    )
                  })
              }
            </div>
          </>
        }
        {
          files.length > 0 &&
          <>
            {
              !isFilesOnly &&
              <div style={{
                color: '#565656',
                fontSize: '24px',
                fontWeight: 'bold',
                borderBottom: '1px solid #c2c9d1'
              }}>
                {'Files'}
              </div>
            }
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              padding: '20px',
              gap: '10px 10px',
              alignItems: 'flex-start'
            }}>
              {
                files
                  .map((fileUrl, index) => {
                    return (
                      <div
                        key={`${fileUrl}-${index}`}
                        style={{
                          color: '#0280c6',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}
                        onClick={() => onClickItem(fileUrl)}
                      >
                        {fileUrl}
                      </div>
                    )
                  })
              }
            </div>
          </>
        }
        {
          standardAnswers.length > 0 &&
          <>
            <div style={{
              color: '#565656',
              fontSize: '24px',
              fontWeight: 'bold',
              borderBottom: '1px solid #c2c9d1'
            }}>
              {'Answers'}
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              padding: '20px',
              paddingLeft: '0px',
              gap: '30px',
              justifyContent: 'left',
            }}>
              {
                standardAnswers
                  .map(({ question, answer }, index) => {
                    return (
                      <div
                        key={`${question}-${index}`}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '15px'
                        }}
                      >
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                          <div style={{ width: '80px', textAlign: 'right', color: '#565656', fontWeight: 'bold' }}>
                            {'Question:'}
                          </div>
                          <div style={{ flex: 1, color: '#565656', fontWeight: 'bold' }}>
                            {question}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                          <div style={{ width: '80px', textAlign: 'right' }}>
                            {'Answer:'}
                          </div>
                          <div style={{ flex: 1 }}>
                            {answer}
                          </div>
                        </div>
                      </div>
                    )
                  })
              }
            </div>
          </>
        }
      </div>
    </Modal>
  )
}